import * as Linking from 'expo-linking';

import { default as Notifications } from './Notifications/Notifications';

export { Linking, Notifications };
